import React from 'react'
import DatePickerMoment from '.'

/**
 * 兼容 年和 月选择器问题
 * origin: https://3x.ant.design/docs/react/faq-cn#%E5%BD%93%E6%88%91%E6%8C%87%E5%AE%9A%E4%BA%86-DatePicker/RangePicker-%E7%9A%84-mode-%E5%B1%9E%E6%80%A7%E5%90%8E%EF%BC%8C%E7%82%B9%E5%87%BB%E5%90%8E%E6%97%A0%E6%B3%95%E9%80%89%E6%8B%A9%E5%B9%B4%E4%BB%BD/%E6%9C%88%E4%BB%BD%EF%BC%9F
 */
class DatePickerYearMonth extends React.Component{
    constructor() {
        super()
        this.state = {
            isopen: false
        }
    }
    render(){

        return (
            <DatePickerMoment
                {...this.props}
                onOpenChange={(status) => {
                    if(status){
                        this.setState({isopen: true})
                    } else {
                        this.setState({isopen: false})
                    }
                }} 
                open={this.state.isopen}
                onPanelChange={(v,dateString) => {
                    this.props.onChange(v, dateString)
                    this.setState({ isopen: false })
                }}
                onChange={() => {
                    this.props.onChange(null)
                }}
            />
        )
    }
}

export default DatePickerYearMonth


// WEBPACK FOOTER //
// ./src/components/DatePicker/YearMonth.jsx